module.exports = __webpack_public_path__ + "static/media/missions-icon-under-maintenance.52f066f6.png";